const MODAL_DEFAULT_CONFIG = {
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'gray modal-lg'
};
export default MODAL_DEFAULT_CONFIG;
